import { Suspense } from "react";
import { Route } from "react-router-dom";
import PrivateRoute from "./private-route";
import Spinner from "../components/spinner/spinner.component";

const routeWrapper = (route) => {
	const { component: Component, layout: Layout, hasBottomNavigation, pageTitle } = route;
	return (
		<Route
			path={route.path}
			exact={route.exact}
			key={route.key}
			element={
				<PrivateRoute isPublic={route.isPublic}>
					<Layout hasBottomNavigation={!!hasBottomNavigation} pageTitle={pageTitle}>
						<Suspense fallback={<Spinner />}>
							<Component />
						</Suspense>
					</Layout>
				</PrivateRoute>
			}
		/>
	);
};

export default routeWrapper;
